"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sendEvent = (eventName, eventData) => {
    if (window && window.gtag) {
        return window.gtag('event', eventName, eventData);
    }
    console.log('Google Analytics is not set up');
};
const config = (trackingId, settings) => {
    if (window && window.gtag) {
        window.gtag('config', `${trackingId}`, settings);
    }
};
const init = (trackingId, options) => {
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    script.async = true;
    document.head.prepend(script);
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        // eslint-disable-next-line
        window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    window.gtag('js', new Date());
    config(trackingId, Object.assign({ debug_mode: options === null || options === void 0 ? void 0 : options.debug }, options === null || options === void 0 ? void 0 : options.configSettings));
};
const gtag = (trackingId, options) => {
    init(trackingId, options);
    return {
        sendEvent,
    };
};
exports.default = gtag;
